var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.724,39.016L49.107,21.983c-0.671-0.446-1.544-0.446-2.215,0L21.276,39.016c-0.734,0.488-1.062,1.4-0.807,2.244 c0.255,0.844,1.033,1.421,1.915,1.421h5.981v19.807h-2.986c-1.104,0-2,0.896-2,2v4.913c0,1.104,0.896,2,2,2h45.242 c1.104,0,2-0.896,2-2v-4.913c0-1.104-0.896-2-2-2h-2.985V42.682h5.98c0.882,0,1.659-0.578,1.914-1.421 C75.786,40.416,75.458,39.504,74.724,39.016z M48,26.05l18.996,12.631h-1.36h-5.251h-9.76h-5.25h-9.76h-5.25h-1.361L48,26.05z  M52.625,62.488V42.682h5.76v19.807H52.625z M37.615,62.488V42.682h5.76v19.807H37.615z M47.375,42.682h1.25v19.807h-1.25V42.682z  M32.365,42.682h1.25v19.807h-1.25V42.682z M68.621,67.401H27.379v-0.913h2.986h5.25h9.76h5.25h9.76h5.251h2.985V67.401z  M63.636,62.488h-1.251V42.682h1.251V62.488z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.13c4d38325f5351d044e4bf8f7d42db3.svg";
export { ForwardRef as ReactComponent };